<template>
  <page-auth />
</template>

<script>
import pageAuth from "./pages/page-auth.vue";
export default {
  name: "App",
  components: {
    pageAuth
  },
}
</script>
